import ReactModal from "react-modal";
import { useEffect } from "react";

// Esto es importante para accesibilidad
ReactModal.setAppElement("#root");

export default function LoadingModal({ isOpen }) {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={() => {}}
      shouldCloseOnOverlayClick={false}
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 9999,
        },
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          marginRight: "-50%",
          transform: "translate(-50%, -50%)",
          borderRadius: "1rem",
          padding: "2rem",
          width: "300px",
          textAlign: "center",
        },
      }}
    >
      <div className="flex flex-col items-center">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-[#A71D2A] border-t-transparent mb-4"></div>
        <h4 className="text-lg font-semibold text-[#A71D2A]">Guardando cambios</h4>
      </div>
    </ReactModal>
  );
}
